import { Injectable } from '@angular/core';
import { BaseStore } from '@macs-frontend/core/store/base.store';
import { makeObservable } from '@macs-frontend/core/utils/mobx';
import { PermissionsApiService } from '@macs-frontend/features/company-management/manage/services/permissions-api.service';
import { PermissionsTableItem } from '@macs-frontend/features/shared/models/permissions-table-item';
import { action } from 'mobx';
import { observable } from 'mobx-angular';

@Injectable({
  providedIn: 'root',
})
export class PermissionsStore extends BaseStore {
  @observable
  permissions: PermissionsTableItem[] = [];

  constructor(readonly permissionsApiService: PermissionsApiService) {
    super();
    makeObservable(this);
    if (this.permissions.length === 0) {
      this.loadPermissions();
    }
  }

  loadPermissions() {
    this.permissionsApiService.getAllPermissions().subscribe(data => {
      this.setPermissions(data);
    });
  }

  @action
  setPermissions(permissions: PermissionsTableItem[]) {
    this.permissions = permissions;
  }
}
